// eslint-disable-next-line no-var
export var Random = {

	scope(startAt, maxItem) {
		let differ = maxItem - startAt;
		Math.random() * differ;
		let num = Math.random() * differ + startAt;
		return parseInt(num, 10);
	},
	raffle(percent) {
		let retu = false;
		percent = Math.round(percent);

		let num = Random.scope(1, 10);

		if (num <= percent) {
			retu = true;
		}

		return retu;
	}
// eslint-disable-next-line semi
}
